import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { setSeo } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import ProductGrid from "@/components/ProductGrid";

export default function Wishlist() {
  const { wishlist } = useCart();
  useEffect(() => setSeo("Wishlist | Adam's The Islamic Boutique", "Your saved favourites."), []);

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-8 py-8 lg:py-12">
      <div className="mb-10">
        <p className="overline mb-2">Saved for Later</p>
        <h1 className="font-serif text-4xl lg:text-5xl text-espresso">Your Wishlist</h1>
      </div>
      {wishlist.length === 0 ? (
        <div className="text-center py-20">
          <Heart className="w-14 h-14 text-champagne/50 mx-auto mb-5" />
          <p className="font-serif text-2xl text-espresso mb-3">Your wishlist is empty</p>
          <p className="text-espresso/50 mb-8">Tap the heart on any product to save it here.</p>
          <Link to="/shop" className="inline-block bg-espresso text-ivory px-10 py-3.5 rounded-full text-sm">Explore Collection</Link>
        </div>
      ) : (
        <ProductGrid products={wishlist.map((w) => ({ ...w, price: w.price, discount_price: w.discount_price }))} cols={4} />
      )}
    </div>
  );
}
